import { FelaCSS, spacing } from '@bridebook/ui';

interface IStyles {
  img: FelaCSS;
  wrapper: FelaCSS;
}

const styles = (): IStyles => ({
  img: {
    borderRadius: spacing[1],
    cursor: 'pointer',
  },
  wrapper: {
    display: 'block',
  },
});

export default styles;
